const TELEGRAM_HOSTS = ['t.me', 'telegram.me', 'telegram.dog', 'telegram.org']
const DISCORD_HOSTS = ['discord.gg', 'discord.com', 'discordapp.com']

export const normalizeXHref = (raw: string): string => {
  const trimmed = raw.trim()
  if (!trimmed) {
    return trimmed
  }
  const cleaned = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed
  if (!cleaned) {
    return trimmed
  }

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      return new URL(trimmed).href
    } catch {
      return `https://x.com/${cleaned}`
    }
  }

  if (isLikelyUrl(cleaned)) {
    return ensureHttps(cleaned)
  }

  return `https://x.com/${cleaned}`
}

export const normalizeTelegramStringHref = (raw: string): string => {
  const trimmed = raw.trim()
  if (!trimmed) {
    return trimmed
  }

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      return new URL(trimmed).href
    } catch {
      return `https://t.me/${trimmed.replace(/^@/, '')}`
    }
  }

  if (isLikelyUrl(trimmed)) {
    try {
      const url = new URL(ensureHttps(trimmed))
      if (hostMatches(url.hostname, TELEGRAM_HOSTS)) {
        return url.href
      }
      return url.href
    } catch {
      // fall through to t.me handle
    }
  }

  const handle = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed
  return `https://t.me/${handle.replace(/^\/+/, '')}`
}

export const normalizeDiscordHref = (raw: string): string => {
  const trimmed = raw.trim()
  if (!trimmed) {
    return trimmed
  }

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      return new URL(trimmed).href
    } catch {
      return `https://discord.gg/${trimmed}`
    }
  }

  if (isLikelyUrl(trimmed)) {
    try {
      const url = new URL(ensureHttps(trimmed))
      if (hostMatches(url.hostname, DISCORD_HOSTS)) {
        return url.href
      }
      return url.href
    } catch {
      // fall through to invite slug
    }
  }

  const slug = trimmed.replace(/^\/+/, '')
  return `https://discord.gg/${slug}`
}

const ensureHttps = (url: string): string => {
  const trimmed = url.trim()
  if (!trimmed) {
    return trimmed
  }
  if (/^[a-z][\d+.a-z-]*:\/\//i.test(trimmed)) {
    return trimmed
  }
  return `https://${trimmed}`
}

const isLikelyUrl = (value: string): boolean =>
  value.includes('.') && !value.includes(' ')

const hostMatches = (hostname: string, roots: Array<string>): boolean => {
  const host = hostname.replace(/^www\./i, '').toLowerCase()
  return roots.some((root) => host === root || host.endsWith(`.${root}`))
}
